export default __webpack_public_path__ + "static/media/icon-linkedin.e205462f.svg";